/* forcast */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    forcast_beginDate: null,
    forcast_lastDate: null,
    forcast_datasets: [],
    forcast_temperature_per_location: [],
    forcast_temperature_per_location_filter: null,
    //v2
    forcast_isLoading: false,
    forecast_data_temp_n_data_rainfall_x_location_destination: {},
}

// getters
const getters = {
    forcast_isLoading: state => {
        return state.forcast_isLoading;
    },
    forcast_date: state => {
        if (state.forcast_beginDate != null) {
            var _start = state.forcast_beginDate.split("T");
            var _end = state.forcast_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.forcast_beginDate, end: state.forcast_lastDate }
        }
    },
    forcast_data_date: state => {
        if (state.forcast_beginDate !== null) {
            var _start = state.forcast_beginDate.split("T");
            var _end = state.forcast_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    forcast_datasets: state => {
        return state.forcast_datasets;
    },
    forcast_temperature_per_location: state => {
        return state.forcast_temperature_per_location;
    },
    forcast_temperature_per_location_filter: state => {
        return state.forcast_temperature_per_location_filter;
    },

}

// actions
const actions = {
    // start /v2 actions
    V2getFocastDatasets(context, payload) {
        state.forcast_isLoading = true;
        state.forcast_temperature_per_location_filter = null;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }

        const request = {
            params: qs.parse(_params)
        };

        // query data
        instance.get('v2/market/informations/forecast', request)
            .then(response => {
                const {
                    date,
                    forecast_data_temp_n_data_rainfall_x_location_destination,
                } = response.data;

                state.forcast_beginDate = date.start;
                state.forcast_lastDate = date.end;
                state.forecast_data_temp_n_data_rainfall_x_location_destination = forecast_data_temp_n_data_rainfall_x_location_destination;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "forcast_temperature_per_location") {
                        context.commit("V2onForcastTemperaturePerLocation", payload);
                    }
                })
                state.forcast_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/informations/forecast] syntax errors under instant.get");
            })
    },

    V2getTemperatureForecastPerLocationFilter(context, payload) {
        if (payload.timerange !== undefined) {
            if (payload.timerange !== null) {
                var rows = state.forecast_data_temp_n_data_rainfall_x_location_destination.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.timerange == payload.timerange) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.forecast_data_temp_n_data_rainfall_x_location_destination.rows;
            }
            context.commit("V2onStatisticTemperaturePerLocation", payload);
        }
    },

    getFocastDatasets(context, payload) {
        console.log("[store/market/informations/forecast] getFocastDatasets() DEPRECATED");
        return;
    },
}

// mutations
const mutations = {
    // start /v2 mutations
    V2onForcastTemperaturePerLocation(state, payload) {
        // --- start dataset for jvector map
        // items = [{label:'',data:0,location_destination:'',avg:0,max_sum,min_sum,max_avg,min_avg]

        var rows = [];
        if (payload.timerange !== undefined) {
            rows = payload.rows_filtered
        } else {
            rows = state.forecast_data_temp_n_data_rainfall_x_location_destination.rows;
        }

        var items = [];
        rows.forEach(function(item, index) {
            var _item = {};
            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);
            if (pos == -1) {
                _item['location_destination'] = item._id.location_destination;
                _item['label'] = item.location_destination;
                _item['data'] = 1;
                _item['max_sum'] = item.avg_forecast_data_temp_max;
                _item['min_sum'] = item.avg_forecast_data_temp_min;
                _item['max_avg'] = item.avg_forecast_data_temp_max;
                _item['min_avg'] = item.avg_forecast_data_temp_min;
                _item['avg'] = (_item['max_sum'] + _item['min_sum']) / 2;
                items.push(_item);
            } else {
                items[pos]['data'] += 1;
                items[pos]['max_sum'] += item.avg_forecast_data_temp_max;
                items[pos]['min_sum'] += item.avg_forecast_data_temp_min;
                items[pos]['max_avg'] = (items[pos]['max_sum'] / items[pos]['data']);
                items[pos]['min_avg'] = (items[pos]['min_sum'] / items[pos]['data']);
                items[pos]['avg'] = (items[pos]['max_avg'] + items[pos]['min_avg']) / 2
            }
        });

        if (payload.timerange !== undefined) {
            state.forcast_temperature_per_location_filter = items;
        } else {
            state.forcast_temperature_per_location = items;
        }
        // --- end dataset for jvector map 
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}